(function () {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  // Keep --header-section-height in sync with the header's real rendered height,
  // since District's own variable isn't reliably set on all templates.
  function setHeaderHeightVar() {
    const height = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-section-height', height + 'px');
  }

  setHeaderHeightVar();

  if (window.ResizeObserver) {
    new ResizeObserver(setHeaderHeightVar).observe(header);
  } else {
    // fallback for older browsers without ResizeObserver
    window.addEventListener('resize', setHeaderHeightVar);
  }

  let lastScrollY = window.scrollY;
  let ticking = false;
  const REVEAL_AFTER = 80;
  const MIN_DELTA = 5;

  function updateHeader() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    if (Math.abs(delta) < MIN_DELTA) {
      ticking = false;
      return;
    }

    if (currentScrollY < REVEAL_AFTER) {
      header.classList.remove('header--hidden', 'header--condensed');
    } else if (delta > 0) {
      header.classList.add('header--hidden');
    } else {
      header.classList.remove('header--hidden');
      header.classList.add('header--condensed');
    }

    lastScrollY = currentScrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();